import { api } from './client';

export interface SubscriptionInfo {
  id: string;
  orgId: string;
  plan: 'free' | 'pro' | 'business';
  status: string;
  usage: number;
  limit: number;
  planName: string;
  planPrice: number;
  currentPeriodStart: string;
  currentPeriodEnd: string;
}

export const billingApi = {
  getSubscription: (orgId: string) =>
    api.get<{ subscription: SubscriptionInfo | null }>(`/orgs/${orgId}/billing`),

  subscribe: (orgId: string, plan: 'pro' | 'business', billingType: 'PIX' | 'BOLETO' | 'CREDIT_CARD') =>
    api.post(`/orgs/${orgId}/billing/subscribe`, { plan, billingType }),

  cancel: (orgId: string) =>
    api.post(`/orgs/${orgId}/billing/cancel`),
};
